module.exports = __webpack_public_path__ + "img/nadvorie_teas.3d061ea0.jpg";